import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IAdminChecklistFullnessType } from '../interfaces/IAdminChecklistFullnessType';

export async function fetchChecklistFullnessTypes(): Promise<IAdminChecklistFullnessType[]> {
  return apiGet<IAdminChecklistFullnessType[]>(
    `${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/checklist-fullness-types`,
  );
}
